import { SelfTapesTab } from 'shared/enums/SelfTapesTab';

export const REQUEST_TAB_LIST = [
  SelfTapesTab.NEW,
  SelfTapesTab.REJECTED,
  SelfTapesTab.FOR_REVIEW,
  SelfTapesTab.APPROVED,
];

export const ACTION_TAB_LIST = [
  SelfTapesTab.REQUESTED,
  SelfTapesTab.CONFIRMED,
  SelfTapesTab.DECLINED,
  SelfTapesTab.NO_RESPONSe,
];
